export const InfoCalloutHtml = `
  <div class="article-callout-paragraph-container article-callout-paragraph-container--info article-info-callout-new">
    &nbsp;
  </div>
  <p class="paragraph-after-callout">&nbsp;</p>
`

export const NoteCalloutHtml = `
  <div class="article-callout-paragraph-container article-callout-paragraph-container--note article-note-callout-new">
    &nbsp;
  </div>
  <p class="paragraph-after-callout">&nbsp;</p>
`

export const WarningCalloutHtml = `
  <div class="article-callout-paragraph-container article-callout-paragraph-container--warning article-warning-callout-new">
    &nbsp;
  </div>
  <p class="paragraph-after-callout">&nbsp;</p>
`